import { Controller } from "@hotwired/stimulus"
import { gsap, Power4, CSSPlugin } from "gsap/all"

gsap.registerPlugin(CSSPlugin)

export default class extends Controller {
  static targets = ["title", "button", "overlay", "iframe", "close"]

  expand () {
    gsap.to(this.closeTarget, {
      opacity: 1,
      duration: 0.4,
      ease: Power4.easeOut
    })

    // Animate and remove title
    if (this.hasTitleTarget) {
      gsap.to(this.titleTarget, {
        opacity: 0,
        y: -30,
        duration: 0.6,
        ease: Power4.easeOut
      })
    }

    // Animate and remove button
    gsap.to(this.buttonTarget, {
      opacity: 0,
      y: -30,
      duration: 0.6,
      ease: Power4.easeOut
    })

    gsap.to(this.overlayTarget, {
      opacity: 0,
      duration: 0.4,
      ease: Power4.easeOut
    })

    // Scroll first, then animate expansion
    this.scrollIntoViewWithOffset(this.element, 64)

    gsap.to(this.element, {
      height: "100vh",
      duration: 1.3,
      ease: Power4.easeOut
    })
  }

  close () {
    gsap.to(this.element, {
      height: "300px",
      duration: 0.8,
      ease: Power4.easeOut
    })

    this.scrollIntoViewWithOffset(this.element, 64)

    if (this.hasTitleTarget) {
      gsap.to(this.titleTarget, {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: Power4.easeOut
      })
    }

    gsap.to(this.buttonTarget, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      ease: Power4.easeOut
    })

    gsap.to(this.overlayTarget, {
      opacity: 0.2,
      duration: 0.4,
      ease: Power4.easeOut
    })

    gsap.to(this.closeTarget, {
      opacity: 0,
      y: -30,
      duration: 0.4,
      ease: Power4.easeOut
    })
  }

  scrollIntoViewWithOffset = (selector, offset) => {
    window.scrollTo({
      behavior: 'smooth',
      top:
        selector.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    })
  }
}